import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Styles from './styles';

class EditableLabel extends Component {
  constructor() {
    super();
    this.state = {
      editing: false,
    };

    this.onDoubleClick = this.onDoubleClick.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onDoubleClick(event) {
    event.preventDefault();
    this.toggleEditing();
  }

  onBlur() {
    this.toggleEditing();
  }

  toggleEditing() {
    this.setState({ editing: !this.state.editing }, () => {
      if (this.state.editing) {
        this.input.focus();
      }
    });
  }

  renderMainElement() {
    if (this.state.editing) {
      return (
        <input
          ref={(component) => {
            this.input = component;
          }}
          onBlur={this.onBlur}
        />
      );
    }

    return <span style={{ ...Styles.label, ...this.props.style }}>{this.props.children}</span>;
  }

  render() {
    return (
      <div onDoubleClick={this.onDoubleClick} style={{ ...Styles.wrapper }}>
        {this.renderMainElement()}
      </div>
    );
  }
}

EditableLabel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  style: StylePropType,
};

EditableLabel.defaultProps = {
  children: null,
  style: {},
};

export default EditableLabel;



// WEBPACK FOOTER //
// ./src/components/EditableLabel/index.js